<div class="dashboard-content p-0">
    <!-- <app-loader 
        *ngIf="isLoading" 
        [fullPage]="true" 
        [message]="'Loading dashboard data...'" [size]="'large'">
    </app-loader> -->

    <!-- Tooltip backdrop overlay for mobile -->
    <div *ngIf="activeTooltip && isMobileView" 
         class="tooltip-backdrop" 
         (click)="activeTooltip = null"></div>

    <!-- Wrap entire dashboard content with loading overlay -->
    <div [class.loading-content]="hasAnyLoadingState()">
        <!-- First Row: Published Articles and Avg Days to Publish -->
        <div class="row g-4 m-0 mb-4">
            <!-- First Row: Published Articles and Avg Days to Publish -->
            <div class="col-md-9 col-sm-12">
                <div class="dashboard-card h-100">
                    <h5 class="section-title">
                        AIPP Published Articles
                        <span class="info-btn-wrapper">
                            <button class="chart-info-btn" 
                                    (click)="toggleTooltip('publishedArticles')" 
                                    type="button" 
                                    [attr.aria-expanded]="activeTooltip === 'publishedArticles'"
                                    aria-label="Show published articles information">
                                <i class="bi bi-info-circle"></i>
                            </button>
                            <div *ngIf="activeTooltip === 'publishedArticles'" 
                                 class="chart-info-tooltip"
                                 [class.mobile-tooltip]="isMobileView"
                                 role="tooltip"
                                 aria-labelledby="published-articles-tooltip-title">
                                <div class="tooltip-content">
                                    <div *ngIf="isMobileView" class="tooltip-header">
                                        <span class="tooltip-title" id="published-articles-tooltip-title">Published Articles Information</span>
                                        <button class="tooltip-close-btn" 
                                                (click)="activeTooltip = null" 
                                                aria-label="Close tooltip">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                    <div *ngFor="let info of tooltipContent.publishedArticles" class="legend-item">
                                        <span class="legend-key">{{info.key}}:</span>
                                        <span class="legend-definition">{{info.definition}}</span>
                                    </div>
                                    <div class="tooltip-explanation">
                                        <p>The red marker & 2025 Target indicate the Target for the current year, and the YTD Target indicates the increase since last month.</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </h5>
                    <div class="row g-3">
                        <!-- Use col-md-4 to ensure 3 charts per row on medium screens and up -->
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let gauge of publishedArticlesGauges">
                            <!-- Individual loader for each gauge -->
                            <!-- <app-loader *ngIf="loadingStates['publishedArticles']" [size]="'medium'" [showMessage]="false"></app-loader> COMMENTED OUT: Moved to conditional rendering -->
                            
                            <!-- Loading state for gauge -->
                            <div *ngIf="loadingStates['publishedArticles']" class="d-flex justify-content-center align-items-center" style="height: 200px;">
                              <app-loader [size]="'medium'" [showMessage]="false"></app-loader>
                            </div>
                            
                            <!-- Chart content - only when NOT loading -->
                            <app-radial-gauge-chart
                                *ngIf="!loadingStates['publishedArticles']"
                                [title]="gauge.title"
                                [value]="gauge.value"
                                [currentYearTarget]="gauge.currentYearTarget"
                                [showMonthTarget]="true"
                                [monthTarget]="gauge.currentMonthTarget"
                                [currentMonthActual]="gauge.currentMonthActual"
                                [percentChangeTargetYearOverYear]="gauge.percentChangeTargetYearOverYear"
                                [percentChangeActualVsTarget]="gauge.percentChangeActualVsTarget"
                                [maxValue]="gauge.maxValue"
                                [color]="gauge.color"
                                [targetColor]="gauge.targetColor"
                                >
                            </app-radial-gauge-chart>
                            <div class="dashboard-gauge-metrics">
                                <div class="dashboard-gauge-label">{{ gauge.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Average Days to Publish (25% width) -->
            <div class="col-md-3 col-sm-12">
                <div class="dashboard-card h-100">
                    <h5 class="section-title">
                        Average Days to Publish
                        <span class="info-btn-wrapper">
                            <button class="chart-info-btn" 
                                    (click)="toggleTooltip('daysToPublish')" 
                                    type="button" 
                                    [attr.aria-expanded]="activeTooltip === 'daysToPublish'"
                                    aria-label="Show days to publish information">
                                <i class="bi bi-info-circle"></i>
                            </button>
                            <div *ngIf="activeTooltip === 'daysToPublish'" 
                                 class="chart-info-tooltip days-to-publish-tooltip"
                                 [class.mobile-tooltip]="isMobileView"
                                 role="tooltip"
                                 aria-labelledby="days-to-publish-tooltip-title">
                                <div class="tooltip-content">
                                    <div *ngIf="isMobileView" class="tooltip-header">
                                        <span class="tooltip-title" id="days-to-publish-tooltip-title">Days to Publish Information</span>
                                        <button class="tooltip-close-btn" 
                                                (click)="activeTooltip = null" 
                                                aria-label="Close tooltip">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                    <div *ngFor="let info of tooltipContent.daysToPublish" class="legend-item">
                                        <span class="legend-key">{{info.key}}:</span>
                                        <span class="legend-definition">{{info.definition}}</span>
                                    </div>
                                    <div class="tooltip-explanation">
                                        <p>The red marker & 2025 Target indicate the Target for the current year, and the YTD Target indicates the increase since last month.</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </h5>
                    <div class="row g-3 h-100">
                        <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                            <!-- Individual loader for days to publish gauge -->
                            <!-- <app-loader *ngIf="loadingStates['daysToPublish']" [size]="'medium'" [showMessage]="false"></app-loader> COMMENTED OUT: Moved to conditional rendering -->
                            
                            <!-- Loading state for gauge -->
                            <div *ngIf="loadingStates['daysToPublish']" class="d-flex justify-content-center align-items-center" style="height: 200px;">
                              <app-loader [size]="'medium'" [showMessage]="false"></app-loader>
                            </div>
                            
                            <!-- Chart content - only when NOT loading -->
                            <app-radial-gauge-chart
                                *ngIf="!loadingStates['daysToPublish']"
                                [title]="daysToPublishGauge[0].title"
                                [value]="daysToPublishGauge[0].value"
                                [currentYearTarget]="daysToPublishGauge[0].currentYearTarget"
                                [monthTarget]="daysToPublishGauge[0].currentMonthTarget"
                                [currentMonthActual]="daysToPublishGauge[0].currentMonthActual"
                                [percentChangeTargetYearOverYear]="daysToPublishGauge[0].percentChangeTargetYearOverYear"
                                [percentChangeActualVsTarget]="daysToPublishGauge[0].percentChangeActualVsTarget"
                                [maxValue]="daysToPublishGauge[0].maxValue"
                                [color]="daysToPublishGauge[0].color"
                                [targetColor]="daysToPublishGauge[0].targetColor"
                                [showPercentChange]="false">
                            </app-radial-gauge-chart>
                            <div class="dashboard-gauge-metrics">
                                <div class="dashboard-gauge-label">{{ daysToPublishGauge[0].title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Second Row: Author Pool and Revenue -->
        <div class="row g-4 m-0 mb-4">
            <!-- Author Pool (50% width) -->
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="dashboard-card h-100">
                    <h5 class="section-title">
                        OGSM Author Pool
                        <span class="info-btn-wrapper">
                            <button class="chart-info-btn" 
                                    (click)="toggleTooltip('authorPool')" 
                                    type="button" 
                                    [attr.aria-expanded]="activeTooltip === 'authorPool'"
                                    aria-label="Show author pool information">
                                <i class="bi bi-info-circle"></i>
                            </button>
                            <div *ngIf="activeTooltip === 'authorPool'" 
                                 class="chart-info-tooltip"
                                 [class.mobile-tooltip]="isMobileView"
                                 role="tooltip"
                                 aria-labelledby="author-pool-tooltip-title">
                                <div class="tooltip-content">
                                    <div *ngIf="isMobileView" class="tooltip-header">
                                        <span class="tooltip-title" id="author-pool-tooltip-title">Author Pool Information</span>
                                        <button class="tooltip-close-btn" 
                                                (click)="activeTooltip = null" 
                                                aria-label="Close tooltip">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                    <div *ngFor="let info of tooltipContent.authorPool" class="legend-item">
                                        <span class="legend-key">{{info.key}}:</span>
                                        <span class="legend-definition">{{info.definition}}</span>
                                    </div>
                                    <div class="tooltip-explanation">
                                        <p>The red marker & 2025 Target indicate the Target for the current year, and the YTD Target indicates the increase since last month.</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </h5>
                    
                    <!-- Marketing Opt-in description - positioned above both charts -->
                    <!-- <div class="marketing-optin-description"> ---Commenting now because it include dot digital data
                        <p class="description-text"><strong>Marketing Opt-In</strong> - The total number of opt-ins reported here does not include Dotdigital opt-outs, bounces, or other suppression reasons.</p>
                    </div> -->
                    
                    <div class="row g-4">
                        <div class="col-md-6 col-sm-6 col-12" *ngFor="let gauge of authorPoolGauges">  
                            <!-- Individual loader for each author pool gauge -->
                            <!-- <app-loader *ngIf="loadingStates['authorPool']" [size]="'medium'" [showMessage]="false"></app-loader> COMMENTED OUT: Moved to conditional rendering -->
                            
                            <!-- Loading state for gauge -->
                            <div *ngIf="loadingStates['authorPool']" class="d-flex justify-content-center align-items-center" style="height: 200px;">
                              <app-loader [size]="'medium'" [showMessage]="false"></app-loader>
                            </div>
                            
                            <!-- Chart content - only when NOT loading -->
                            <app-radial-gauge-chart
                                *ngIf="!loadingStates['authorPool']"
                                [title]="gauge.title"
                                [value]="gauge.value"
                                [currentYearTarget]="gauge.currentYearTarget"
                                [showMonthTarget]="true"
                                [monthTarget]="gauge.currentMonthTarget"
                                [currentMonthActual]="gauge.currentMonthActual"
                                [percentChangeTargetYearOverYear]="gauge.percentChangeTargetYearOverYear"
                                [percentChangeActualVsTarget]="gauge.percentChangeActualVsTarget"
                                [maxValue]="gauge.maxValue"
                                [color]="gauge.color"
                                [targetColor]="gauge.targetColor">
                            </app-radial-gauge-chart>
                            <div class="dashboard-gauge-metrics">
                                <div class="dashboard-gauge-label">{{ gauge.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Revenue (50% width) -->
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="dashboard-card h-100">
                    <h5 class="section-title">
                        Revenue <span class="info-text">( as of {{ revenueAsOfLabel }} )</span>
                        <span class="info-btn-wrapper">
                            <button class="chart-info-btn" 
                                    (click)="toggleTooltip('revenue')" 
                                    type="button" 
                                    [attr.aria-expanded]="activeTooltip === 'revenue'"
                                    aria-label="Show revenue information">
                                <i class="bi bi-info-circle"></i>
                            </button>
                            <div *ngIf="activeTooltip === 'revenue'" 
                                 class="chart-info-tooltip"
                                 [class.mobile-tooltip]="isMobileView"
                                 role="tooltip"
                                 aria-labelledby="revenue-tooltip-title">
                                <div class="tooltip-content">
                                    <div *ngIf="isMobileView" class="tooltip-header">
                                        <span class="tooltip-title" id="revenue-tooltip-title">Revenue Information</span>
                                        <button class="tooltip-close-btn" 
                                                (click)="activeTooltip = null" 
                                                aria-label="Close tooltip">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                    <div *ngFor="let info of tooltipContent.revenue" class="legend-item">
                                        <span class="legend-key">{{info.key}}:</span>
                                        <span class="legend-definition">{{info.definition}}</span>
                                    </div>
                                    <div class="tooltip-explanation">
                                        <p>The red marker & 2025 Target indicate the Target for the current year, and the YTD Target indicates the increase since last month.</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </h5>
                    <div class="row g-4">
                        <div class="col-md-6 col-sm-6 col-12" *ngFor="let gauge of revenueGauges">
                            <!-- Individual loader for each revenue gauge -->
                            <!-- <app-loader *ngIf="loadingStates['revenue']" [size]="'medium'" [showMessage]="false"></app-loader> COMMENTED OUT: Moved to conditional rendering -->
                            
                            <!-- Loading state for gauge -->
                            <div *ngIf="loadingStates['revenue']" class="d-flex justify-content-center align-items-center" style="height: 200px;">
                              <app-loader [size]="'medium'" [showMessage]="false"></app-loader>
                            </div>
                            
                            <!-- Chart content - only when NOT loading -->
                            <app-radial-gauge-chart
                                *ngIf="!loadingStates['revenue']"
                                [title]="gauge.title"
                                [value]="gauge.value"
                                [currentYearTarget]="gauge.currentYearTarget"
                                [showMonthTarget]="true"
                                [monthTarget]="gauge.currentMonthTarget"
                                [currentMonthActual]="gauge.currentMonthActual"
                                [percentChangeTargetYearOverYear]="gauge.percentChangeTargetYearOverYear"
                                [percentChangeActualVsTarget]="gauge.percentChangeActualVsTarget"
                                [maxValue]="gauge.maxValue"
                                [color]="gauge.color"
                                [targetColor]="gauge.targetColor"
                                [alwaysShowSuffix]="'M'">
                            </app-radial-gauge-chart>
                            <div class="dashboard-gauge-metrics">
                                <div class="dashboard-gauge-label">{{ gauge.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="child-view-container p-0 w-100">
    <router-outlet></router-outlet>
</div>